<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div
        class="d-flex align-items-center justify-content-between card-header border-0 not-in-print"
      >
        <h5 class="card-title font-bold py-3">گزارش فروش و مرجوعی</h5>
        <div>
          <button id="print-list" @click="print" class="btn btn-primary">
            <i class="feather-printer"></i>
          </button>
          <ExcelDownload
            class="mr-2"
            :url="
              `admin/accounting-report/product-sell?start_date=${filter.date.startDate}&end_date=${filter.date.endDate}`
            "
          />
        </div>
      </div>
      <div class="card-body">
        <b-form
          @submit.prevent="submitHandler"
          class="row justify-content-between not-in-print"
        >
          <div class="col-5">
            <label>فیلتر تاریخ</label>
            <div class="row">
              <div class="col-6 d-flex">
                <span class="ml-2">از</span>
                <date-picker
                  type="date"
                  v-model="filter.date.startDate"
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jDD"
                />
              </div>
              <div class="col-6 d-flex">
                <span class="ml-2">تا</span>
                <date-picker
                  name="noname"
                  type="date"
                  v-model="filter.date.endDate"
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jDD"
                />
              </div>
            </div>
          </div>
          <div class="col-2">
            <label>نوع فروش</label>
            <b-form-select v-model="filter.sell_type" :options="options">
            </b-form-select>
          </div>
          <div class="col-4 p-0">
            <label>جستجوی محصول</label>
            <ProductSearch
              :selectable="true"
              :showLabel="false"
              :productOnly="true"
              :fullWidth="true"
              :disabled="disabled"
              @selectProduct="selectProduct"
            />
          </div>
          <div class="col-md-12 mt-4">
            <button :disabled="disabled" type="submit" class="btn btn-primary">
              فیلتر
            </button>
            <button
              @click="removeFilter"
              :disabled="disabled"
              type="button"
              class="btn btn-warning mr-2"
            >
              برداشتن فیلتر
            </button>
          </div>
        </b-form>
        <div class="mt-5 p-3 border">
          <div>
            <h5 class="card-title font-bold pt-5 text-center">
              گزارش فروش و مرجوعی تاریخ
              {{ filteredDate(appliedFilter.date.startDate) }}
              <template
                v-if="
                  appliedFilter.date.startDate != appliedFilter.date.endDate
                "
              >
                تا تاریخ
                {{ filteredDate(appliedFilter.date.endDate) }}
              </template>
            </h5>
          </div>
          <div class="d-flex align-items-center">
            <!-- مجموع گزارش فروش -->
            <div class="ml-5" v-if="reportsTotal && reportsTotal.length">
              <div>
                <h6 class="card-title font-bold pt-5">
                  مجموع فروش
                </h6>
              </div>
              <b-table
                class="mt-2"
                v-if="reportsTotal && reportsTotal.length"
                bordered
                striped
                :fields="fieldsTotal"
                :items="reportsTotal"
                responsive="sm"
              >
                <template v-slot:cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template v-slot:cell(count_sell_online)="data">
                  {{ data.item.count_sell_online | price }}
                </template>
                <template v-slot:cell(count_sell_real)="data">
                  {{ data.item.count_sell_real | price }}
                </template>
                <template v-slot:cell(count_sell_total)="data">
                  {{ data.item.count_sell_total | price }}
                </template>
                <template v-slot:cell(total_product_sell)="data">
                  {{ data.item.total_product_sell | price }}
                </template>
                <template v-slot:cell(total_product_discount)="data">
                  {{ data.item.total_product_discount | price }}
                </template>
              </b-table>
              <div v-else class="alert alert-primary mt-5 not-in-print">در حال بارگزاری</div>
            </div>
            <!-- مجموع گزارش مرجوعی -->
            <div v-if="refundReportsTotal && refundReportsTotal.length">
              <div>
                <h6 class="card-title font-bold pt-5">
                  مجموع مرجوعی
                </h6>
              </div>
              <b-table
                class="mt-2"
                v-if="refundReportsTotal && refundReportsTotal.length"
                bordered
                striped
                :fields="refundFieldsTotal"
                :items="refundReportsTotal"
                responsive="sm"
              >
                <template v-slot:cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template v-slot:cell(count_refund_online)="data">
                  {{ data.item.count_refund_online | price }}
                </template>
                <template v-slot:cell(count_refund_real)="data">
                  {{ data.item.count_refund_real | price }}
                </template>
                <template v-slot:cell(count_refund_total)="data">
                  {{ data.item.count_refund_total | price }}
                </template>
                <template v-slot:cell(total_product_refund)="data">
                  {{ data.item.total_product_refund | price }}
                </template>
                <template v-slot:cell(total_product_refund_discount)="data">
                  {{ data.item.total_product_refund_discount | price }}
                </template>
              </b-table>
              <div v-else class="alert alert-primary mt-5 not-in-print">در حال بارگزاری</div>
            </div>
          </div>
          <!-- جزئیات گزارش فروش -->
          <div v-if="reports">
            <div>
              <h6 class="card-title font-bold pt-5">
                جزئیات گزارش فروش
              </h6>
            </div>
            <b-table
              class="mt-5"
              v-if="reports"
              bordered
              striped
              :fields="fields"
              :items="reports"
              responsive="sm"
            >
              <template v-slot:cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template v-slot:cell(product_code)="data">
                {{ data.item.product_code }}
              </template>
              <template v-slot:cell(title)="data">
                {{ data.item.title }}
              </template>
              <template v-slot:cell(count_sell_online)="data">
                {{ data.item.count_sell_online | price }}
              </template>
              <template v-slot:cell(count_sell_real)="data">
                {{ data.item.count_sell_real | price }}
              </template>
              <template v-slot:cell(count_sell_total)="data">
                {{ data.item.count_sell_total | price }}
              </template>
              <template v-slot:cell(total_product_sell)="data">
                {{ data.item.total_product_sell | price }}
              </template>
              <template v-slot:cell(total_product_discount)="data">
                {{ data.item.total_product_discount | price }}
              </template>
            </b-table>
            <div v-else class="alert alert-primary mt-5 not-in-print">در حال بارگزاری</div>
          </div>
                    <!-- جزئیات گزارش مرجوعی -->
                    <div v-if="refundReports">
            <div>
              <h6 class="card-title font-bold pt-5">
                جزئیات گزارش مرجوعی
              </h6>
            </div>
            <b-table
              class="mt-5"
              v-if="refundReports"
              bordered
              striped
              :fields="refundFields"
              :items="refundReports"
              responsive="sm"
            >
              <template v-slot:cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template v-slot:cell(product_code)="data">
                {{ data.item.product_code }}
              </template>
              <template v-slot:cell(title)="data">
                {{ data.item.title }}
              </template>
              <template v-slot:cell(count_refund_online)="data">
                {{ data.item.count_refund_online | price }}
              </template>
              <template v-slot:cell(count_refund_real)="data">
                {{ data.item.count_refund_real | price }}
              </template>
              <template v-slot:cell(count_refund_total)="data">
                {{ data.item.count_refund_total | price }}
              </template>
              <template v-slot:cell(total_product_refund)="data">
                {{ data.item.total_product_refund | price }}
              </template>
              <template v-slot:cell(total_product_refund_discount)="data">
                {{ data.item.total_product_refund_discount | price }}
              </template>
            </b-table>
            <div v-else class="alert alert-primary mt-5 not-in-print">در حال بارگزاری</div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  BTable,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelectOption,
  BFormSelect,
  BTooltip,
} from "bootstrap-vue";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload.vue";

class Filter {
  constructor() {
    this.date = {
      startDate: new Date().toISOString().split("T")[0],
      endDate: new Date().toISOString().split("T")[0],
    };
    this.product_id = null;
    this.sell_type = null;
  }
  set(filters) {
    Object.entries(filters).forEach(([index, value]) => {
      this[index] = value;
    });
  }
}

export default {
  name: "AccountingProduct",
  components: {
    BTable,
    BFormGroup,
    BFormInput,
    BForm,
    BFormSelectOption,
    BFormSelect,
    BTooltip,
    ProductSearch,
    ExcelDownload,
  },
  data() {
    return {
      disabled: true,
      reports: null,
      refundReports: null,
      reportsTotal: [],
      refundReportsTotal: [],
      filter: new Filter(),
      appliedFilter: new Filter(),
      fields: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "product_code",
          label: "کد محصول",
        },
        {
          key: "title",
          label: "عنوان محصول",
        },
        {
          key: "count_sell_real",
          label: "تعداد فروش حضوری",
        },
        {
          key: "count_sell_online",
          label: "تعداد فروش آنلاین",
        },
        {
          key: "count_sell_total",
          label: "مجموع تعداد فروش",
        },
        {
          key: "total_product_sell",
          label: "مجموع مبلغ فروش",
        },
        {
          key: "total_product_discount",
          label: "مجموع مبلغ تخفیف",
        },
      ],
      fieldsTotal: [
        {
          key: "count_sell_real",
          label: "تعداد فروش حضوری",
        },
        {
          key: "count_sell_online",
          label: "تعداد فروش آنلاین",
        },
        {
          key: "count_sell_total",
          label: "مجموع تعداد فروش",
        },
        {
          key: "total_product_sell",
          label: "مجموع مبلغ فروش",
        },
        {
          key: "total_product_discount",
          label: "مجموع مبلغ تخفیف",
        },
      ],
      refundFieldsTotal: [
        {
          key: "count_refund_real",
          label: "تعداد مرجوعی حضوری",
        },
        {
          key: "count_refund_online",
          label: "تعداد مرجوعی آنلاین",
        },
        {
          key: "count_refund_total",
          label: "مجموع تعداد مرجوعی",
        },
        {
          key: "total_product_refund",
          label: "مجموع مبلغ مرجوعی",
        },
        {
          key: "total_product_refund_discount",
          label: "مجموع مبلغ تخفیف مرجوعی",
        },
      ],
      refundFields: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "product_code",
          label: "کد محصول",
        },
        {
          key: "title",
          label: "عنوان محصول",
        },
        {
          key: "count_refund_real",
          label: "تعداد فروش حضوری",
        },
        {
          key: "count_refund_online",
          label: "تعداد فروش آنلاین",
        },
        {
          key: "count_refund_total",
          label: "مجموع تعداد فروش",
        },
        {
          key: "total_product_refund",
          label: "مجموع مبلغ فروش",
        },
        {
          key: "total_product_refund_discount",
          label: "مجموع مبلغ تخفیف",
        },
      ],
      options: null,
    };
  },
  created() {
    this.loadData();
    this.sellTypesOptions();
  },
  methods: {
    filteredDate(date) {
      return this.$options.filters.Date(date);
    },
    selectProduct(product) {
      this.filter.product_id = product.id;
    },
    print() {
      print();
    },
    removeFilter() {
      this.filter = new Filter();
      this.loadData();
    },
    submitHandler() {
      this.loadData();
    },
    async loadData() {
      try {
        this.appliedFilter.set(this.filter);
        this.disabled = true;
        const response = await this.$axios.get(
          "admin/accounting-report/product-sell",
          {
            params: {
              start_date: this.appliedFilter.date.startDate,
              end_date: this.appliedFilter.date.endDate,
              product_id: this.appliedFilter.product_id,
              sell_type: this.appliedFilter.sell_type,
            },
          }
        );
        this.refundReports = response.data.data.refund;
        let single_reports = response.data.data.report;
        this.reports = Object.keys(single_reports).map(
          (key) => single_reports[key]
        );
        this.reportsTotal = [];
        response.data.data.report_totals
          ? this.reportsTotal.push(response.data.data.report_totals)
          : {};

        this.refundReportsTotal = [];
        response.data.data.refund_totals
          ? this.refundReportsTotal.push(response.data.data.refund_totals)
          : {};
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    async sellTypesOptions() {
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/reports/sell-types");
        this.options = response.data.data.options;
      } catch (error) {
        this.$root.notify(error);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>
<style>
@media print {
  .not-in-print {
    display: none !important;
  }
}
</style>
